import { css } from '@emotion/css';
import { Color } from 'src/styles';

export const value = css`
  color: ${Color.Brand6};
`;
